import React, { PropsWithChildren } from "react";
import { View, StatusBar as RNStatusBar, StyleSheet } from "react-native";
import DropShadow from "react-native-drop-shadow";
import { StatusBar } from "expo-status-bar";

import css from "styles";
import { sizes, colors } from "assets/constants";

const bgColor = colors.white;

const HeaderLayout: React.FC<PropsWithChildren & { removeSpace?: boolean }> = ({
  children,
  removeSpace,
}) => {
  return (
    <>
      <StatusBar style="dark" backgroundColor={bgColor} />
      {!removeSpace && <View style={{ height: RNStatusBar.currentHeight }} />}

      <DropShadow style={styles.dropShadow}>
        <View style={styles.contentWrapper}>{children}</View>
      </DropShadow>
    </>
  );
};

const marginTop = sizes.isLargeScreen ? sizes.space : 0;
const width = sizes.isLargeScreen ? "98%" : "100%";
const height = 65;
const borderRadius = sizes.radius.md;

const styles = StyleSheet.create({
  dropShadow: {
    width,
    height,
    marginTop,
    alignSelf: "center",
    borderRadius,
    ...css.dropShadow(0, 0, 1, 5, "#dfdfdf"),
  },

  contentWrapper: {
    width: "100%",
    height: "100%",
    alignSelf: "center",
    borderRadius,
    backgroundColor: bgColor,
  },
});

export default HeaderLayout;
